import { render, staticRenderFns } from "./BulletinAlert.vue?vue&type=template&id=d6240ec0"
import script from "./BulletinAlert.vue?vue&type=script&lang=js"
export * from "./BulletinAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports